<template>
  <div>
    <v-youtube
      :video-id="youtubeId"
      :player-width="getPlayerWidth()"
      :player-height="getPlayerHeight()"
      :player-vars="{start: 0, autoplay: autoPlay ? 1 : 0}"
      @ready="ready"
      @playing="emitProgress()"
      @ended="setFinished"
      ref="youtube"
    />
  </div>
</template>

<script>
import { YouTubePlayer } from 'vue-youtube-embed';

export default {
  name: 'Video',
  props: {
    youtubeId: {
      type: String,
      required: true,
    },
    autoPlay: {
      type: Boolean,
      default() {
        return false;
      },
    },
    fullSize: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      playing: false,
      progress: 0,
      duration: null,
      fastForwarded: false,
      started: false,
      finished: false,
      destroyed: false,
    };
  },
  components: {
    'v-youtube': YouTubePlayer,
  },
  methods: {
    setProgress() {
      if (!this.$refs.youtube) {
        this.progress = 0;
        return;
      }

      if (!this.duration) {
        this.duration = this.player.getDuration();
      }

      const newProgress = this.player.getCurrentTime() / this.duration;
      const expectedProgress = this.progress + (1 / this.duration);

      if (newProgress - expectedProgress > 0.1) {
        // User fast forwarded the audio;
        this.fastForwarded = true;
        this.progress = 0;
      } else {
        this.progress = newProgress;
      }
    },
    emitProgress() {
      if (!this.started) {
        this.started = true;
        this.$emit('play');
      }
      if (!this.timeOutRunning) {
        this.timeOutRunning = true;
        setTimeout(
          () => {
            this.setProgress();
            this.$emit('playing', {
              progress: this.progress,
              fastForwarded: this.fastForwarded,
            });

            if (this.player.getPlayerState() !== 3 && !this.destroyed && !this.finished) {
              this.timeOutRunning = false;
              this.emitProgress();
            }
          },
          1000,
        );
      }
    },
    getPlayerHeight() {
      if (this.fullSize && window.innerWidth > 500) {
        return window.innerHeight;
      }
      if (window.innerWidth < 400) {
        return '160px';
      }
      if (window.innerWidth < 450) {
        return '200px';
      }
      if (window.innerWidth < 500) {
        return '250px';
      }
      return '300px';
    },
    getPlayerWidth() {
      return '100%';
    },
    ready(event) {
      this.player = event.target;
    },
    setFinished() {
      this.finished = true;
      this.$emit('finished');
      this.playing = false;
    },
  },
  destroyed() {
    this.destroyed = true;
  },
};
</script>
